import {Common} from "../../types/models/Common";
import {
  CommonActionTypes,
  DESELECT_COMPANY, DESELECT_DATA,
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SELECT_COMPANY,
  SELECT_MODULE,
  SELECT_SELLER,
  SHOW_MESSAGE,
  TOGGLE_APP_DRAWER,
} from "../../types/actions/Common.action";

const INIT_STATE: Common = {
  error: "",
  loading: false,
  idCompanySelected: "",
  isAppDrawerOpen: false,
  updatingContent: false,
  message: "",
  companySelected: false,
  idSellerSelected: "",
  module: "company"
};

const CommonReducer = (
  state = INIT_STATE,
  action: CommonActionTypes
): Common => {
  switch (action.type) {
    case FETCH_START: {
      return { ...state, error: "", message: "", loading: true };
    }
    case FETCH_SUCCESS: {
      return {
        ...state,
        error: "",
        message: "",
        loading: false,
        updatingContent: false,
      };
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        error: "",
        message: action.message,
        loading: false,
        updatingContent: false,
      };
    }
    case FETCH_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.error,
        message: "",
        updatingContent: false,
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        loading: false,
        error: "",
        message: "",
        updatingContent: false,
      };
    }
    case TOGGLE_APP_DRAWER: {
      return {
        ...state,
        isAppDrawerOpen: !state.isAppDrawerOpen,
      };
    }
    case SELECT_COMPANY: {
      return {
        ...state,
        idCompanySelected: action.id,
        companySelected: true
      }
    }
    case DESELECT_COMPANY: {
      return {
        ...state,
        idCompanySelected: undefined,
        companySelected: false
      }
    }
    case DESELECT_DATA: {
      return {
        ...state,
        idCompanySelected: undefined,
        companySelected: false,
        idSellerSelected: undefined,
        module: undefined
      }
    }
    case SELECT_MODULE: {
      return {
        ...state,
        module: action.module,
      }
    }
    case SELECT_SELLER: {
      return {
        ...state,
        idSellerSelected: action.id,
      }
    }
    default:
      return state;
  }
};
export default CommonReducer;
